import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import { analyticsService } from '../../services/AnalyticsService';

import * as Icons from 'react-bootstrap-icons';


export function Export() {
  const boatList = useSelector((state: RootState) => state.boatList);
  const [copied, setCopied] = useState(false);

  // Get current group to count boats
  const currentGroup = boatList.boatGroupList.find((group) => group.id === boatList.currentGroupId);
  const boatCount = currentGroup?.boatDetails?.length || 0;

  const exportString: string = JSON.stringify(boatList, undefined, 2);

  function onCopy() {
    console.log('Export.onCopy');
    setCopied(true);

    // Track data export
    analyticsService.logEvent('data_export', {
      export_format: 'json',
      record_count: boatCount,
      feature_name: 'export_container',
    });
  }

  // TODO layout the copy button to be top right of the pre formatted section
  return <Container>
    <h1 className="header">Export Boat List</h1>
    <p>This structure will be able to be imported into the application on another device</p>
    <span style={{ cursor: 'pointer' }} onClick={() => {
      navigator.clipboard.writeText(exportString).then(onCopy);
    }}>
      {copied ? <Icons.ClipboardCheck /> : <Icons.Clipboard />}
    </span>
    <pre>{exportString}</pre>
  </Container>;
}
